export default __webpack_public_path__ + "static/media/Avatar-23.9d1cf64c.svg";